import React, { FunctionComponent, useCallback } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Locale, Translation } from 'locale'
import { GridActions } from 'store/grid'
import { GlobalGridSettings } from 'store/grid/gridTypes'
import { showOnlyUsersSalesActivitySelector, showSalesCoverToggleSelector } from 'selectors/gridSelectors'
import { ToggleField } from '../../toggle'
import { ToolbarToggleWrapper } from 'view/components/datagrid/toolbar/toolbarStyles'
import { Tooltip } from '../../tooltip'

interface SalesCoverFilterSwitchProps {
  showOnlyUsersSalesActivity: boolean
  onSaveGlobalGridSettings: (globalGridSettings: Partial<GlobalGridSettings>) => unknown
  showToggle: boolean
}

const mapStateToProps = createStructuredSelector({
  showOnlyUsersSalesActivity: showOnlyUsersSalesActivitySelector,
  showToggle: showSalesCoverToggleSelector
})

const mapDispatchToProps = {
  onSaveGlobalGridSettings: GridActions.saveGlobalGridSettings
}

const SalesCoverFilterSwitchComponent: FunctionComponent<SalesCoverFilterSwitchProps> = props => {
  const { onSaveGlobalGridSettings, showOnlyUsersSalesActivity, showToggle } = props

  const handleSwitch = useCallback(
    (checked: boolean) => {
      onSaveGlobalGridSettings({
        showOnlyUsersSalesActivity: checked
      })
    },
    [onSaveGlobalGridSettings]
  )

  return showToggle ? (
    <ToolbarToggleWrapper>
      <Tooltip tooltip={Locale.translate(Translation.SC_SHOW_MY_SALES_RFQS_TOOLTIP)}>
        <div>
          <ToggleField
            dataTestIdField={'SalesCoverFilterSwitch-ToggleField-ShowOnlyUsersSalesActivity>'}
            checked={showOnlyUsersSalesActivity}
            onUpdate={handleSwitch}
            label={Locale.translate(Translation.SC_SHOW_MY_SALES_RFQS)}
          />
        </div>
      </Tooltip>
    </ToolbarToggleWrapper>
  ) : null
}

export const SalesCoverFilterSwitch = connect(mapStateToProps, mapDispatchToProps)(SalesCoverFilterSwitchComponent)
